









import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import rtStep from "@/components/couponcancel/rtStep.vue";

const couponModule = namespace("coupon");

@Component({
  components: {
    rtStep
  }
})
export default class CouponVerification extends Vue {
  @couponModule.State("couponSearchStep") active!: number;
}
